<template>
  <el-dialog :visible.sync="dialogVisible" width="320px"  center>
      <div v-if="form.step === 1" class="inputCon">
        <el-input
          v-model="form.captcha"
          placeholder="请输入内容"
          clearable
        ></el-input>
        <img :src="form.url" @click="getCode()" title="点击刷新" alt="" />
      </div>
      <div v-else class="info">
        <p>联系人：{{ form.chairman }}</p>
        <p>手机号：{{ form.enterprise_phone }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <div v-if="form.step === 1">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="sure">确 定</el-button>
        </div>
        <div v-else>
          <el-button type="primary" @click="dialogVisible = false"
            >确 认</el-button
          >
        </div>
      </span>
    </el-dialog>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return{
      form: {
        type: 1,
        id: "",
        key: "",
        url: "",
        step: 1,
        captcha: "",
        chairman: "",
        enterprise_phone: "",
      },
      dialogVisible: false,
    }
  },
  methods: {
    getStr4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    },
    getUuid() {
      return (
        this.getStr4() +
        this.getStr4() +
        this.getStr4() +
        this.getStr4() +
        this.getStr4() +
        this.getStr4() +
        this.getStr4() +
        this.getStr4()
      );
    },
    init(type,id) {
      this.form = {
        id: id,
        type: type,
        key: "",
        url: "",
        step: 1,
        captcha: "",
        chairman: "",
        enterprise_phone: "",
      };
      this.getCode('init');
    },
    getCode(init) {
      this.form.key = this.getUuid();
      $.ajax({
        type: "get",
        url: "/officialapi/captcha/captcha",
        async: true,
        data: {
          key: this.form.key,
        },
        xhrFields: {
          responseType: "blob",
        },
        success: (data) => {
          this.form.url = URL.createObjectURL(data);
          if (init) {
            this.dialogVisible = true;
          }
        },
      });
    },
    sure() {
      if (!this.form.captcha) {
        this.$message.error("请输入验证码");
        return;
      }
      var param = "";
      var url = "";
      if (this.form.type === 1) {
        param = {
          brand_id: this.form.id,
          key: this.form.key,
          captcha: this.form.captcha,
        }
        url = "/officialapi/brand/getContactInfo";
      }
      if (this.form.type === 2) {
        param = {
          supplier_id: this.form.id,
          key: this.form.key,
          captcha: this.form.captcha,
        }
        url = "/officialapi/supplier/getContactInfo"
      } 
      $.ajax({
        type: "get",
        url: url,
        async: true,
        data: param,
        success: (data) => {
          if (data["code"] == 0) {
            this.form.step = 2;
            if (this.form.type === 1) {
                this.form.chairman = data.data.chairman;
                this.form.enterprise_phone = data.data.enterprise_phone;
            } else {
                this.form.chairman = data.data.contacts_name;
                this.form.enterprise_phone = data.data.contacts_phone;
            }
          } else {
            this.$message.error(data.msg);
          }
        },
      });
    },
  }
}
</script>

<style lang="less" scoped>
.el-dialog {
  .inputCon {
    display: flex;
  }
  img {
    margin-left: 20px;
    width: 100px;
  }
  .info {
    font-family: Source Han Sans;
    font-size: 16px;
    font-weight: 500;
    line-height: 34px;
    letter-spacing: normal;
    color: #222222;
  }
}
</style>